// The cart's product labels. The table column, its filter and the list view tags all read this list,
// so a new label (e.g. Mixed SKU) is one more entry here.
const LABELS = [
    {
        id: "volume_pricing",
        fallback: "Volume Pricing",
        isEnabled: (context) => context.canReadPrices !== false,
        appliesTo: (item) => !!item.has_volume_pricing,
    },
    {
        id: "backorder",
        fallback: "Backorder",
        isEnabled: (context) => !!context.hasInventory,
        appliesTo: (item, context) => !!context.allowBackorder?.(item),
    },
];

/**
 * Labels the cart can show right now, as [{id, text}] for the column filter.
 * @param {{canReadPrices?: boolean, hasInventory?: boolean}} context
 * @param {Object} translations window.bo.cartTranslations
 */
export function getAvailableCartLabels(context = {}, translations = {}) {
    return LABELS.filter((label) => label.isEnabled(context)).map((label) => ({
        id: label.id,
        text: translations[label.id] || label.fallback,
    }));
}

/**
 * Ids of the labels one cart item carries, in display order.
 * @param {Object} item cart item
 * @param {{canReadPrices?: boolean, hasInventory?: boolean, allowBackorder?: function(Object): boolean}} context
 */
export function getCartItemLabelIds(item, context = {}) {
    return LABELS.filter((label) => label.isEnabled(context) && label.appliesTo(item, context)).map(
        (label) => label.id
    );
}

/**
 * Keeps the items that carry every selected label; no selection keeps everything.
 * Works on an array or on an object keyed by item id, and returns the same shape.
 */
export function filterItemsByLabels(items, selectedIds, context = {}) {
    if (!selectedIds || selectedIds.length === 0) {
        return items;
    }

    const matches = (item) => {
        const itemLabelIds = getCartItemLabelIds(item, context);
        return selectedIds.every((id) => itemLabelIds.includes(id));
    };

    if (Array.isArray(items)) {
        return items.filter(matches);
    }

    return Object.fromEntries(Object.entries(items).filter(([, item]) => matches(item)));
}
